import classNames from 'classnames'

import PleaseSupportUs from '@/components/PleaseSupportUs/PleaseSupportUs'

import styles from './XrxjJYQoXuJGrL.module.scss' // Obfuscated filename to avoid MV's override

type Props = {
  numCols?: number
  tall?: boolean
  wide?: boolean
}

const ContentHint = ({ numCols, tall, wide }: Props) => (
  <div className={classNames(styles.contentHint, { [styles.wide]: wide, [styles.tall]: tall }, 'd-block')}>
    <div className={classNames(styles.card, { 'w-100': numCols === 1 }, 'position-relative')}>
      {/* <div className='mv_slot_target' data-slot='content' data-hint-slot-sizes='300x250' /> */}
      <div className='mv_slot_target' data-slot='content' />
      <PleaseSupportUs always className={styles.pleaseSupportUs} />
    </div>
  </div>
)

export default ContentHint
